import { render, staticRenderFns } from "./SalesOrderChangeList.vue?vue&type=template&id=6ed50202&"
import script from "./SalesOrderChangeList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderChangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports